import axios from 'axios';
import { getApiUrl } from '@/config/api';
import authService from '@/shared/services/auth';

class CatDimensionService {
  constructor() {
    this.dimensiones = [];
    this.loading = false;
    this.error = null;
    this.selectedEmpresa = null;
  }

  async initialize() {
    // Esperar un poco para que la empresa se seleccione
    await this.waitForEmpresa();
    await this.listar();
  }

  // Esperar a que la empresa esté seleccionada
  async waitForEmpresa() {
    let attempts = 0;
    const maxAttempts = 50; // 5 segundos máximo
    
    while (attempts < maxAttempts) {
      this.selectedEmpresa = authService.getSelectedEmpresa();
      if (this.selectedEmpresa && this.selectedEmpresa.EmpresaId) {
        console.log('Empresa encontrada para CatDimension:', this.selectedEmpresa);
        return;
      }
      
      // Esperar 100ms antes del siguiente intento
      await new Promise(resolve => setTimeout(resolve, 100));
      attempts++;
    }
    
    // Si no se encuentra empresa después de los intentos
    this.error = 'No se pudo obtener la empresa seleccionada';
    console.error('No se pudo obtener empresa para CatDimension después de', maxAttempts, 'intentos');
  }

  async listar() {
    this.loading = true;
    this.error = null;
    
    try {
      // Verificar que tenemos empresa seleccionada
      if (!this.selectedEmpresa || !this.selectedEmpresa.EmpresaId) {
        this.selectedEmpresa = authService.getSelectedEmpresa();
        if (!this.selectedEmpresa || !this.selectedEmpresa.EmpresaId) {
          this.loading = false;
          return { success: false, data: [], message: 'Debe elegir una empresa antes de poder continuar.' };
        }
      }

      const token = authService.getToken();
      const response = await axios.post(getApiUrl('/api/CatDimension/listar'), {
        EmpresaId: this.selectedEmpresa.EmpresaId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      
      // Filtrar por empresa en el frontend como medida de seguridad adicional
      const allDimensiones = response.data || [];
      this.dimensiones = allDimensiones.filter(dimensione => dimensione.EmpresaId === this.selectedEmpresa.EmpresaId);
      this.loading = false;
      
      console.log('Dimensiones cargados:', this.dimensiones.length, 'de', allDimensiones.length, 'total');
      console.log('Empresa del usuario:', this.selectedEmpresa.EmpresaId);
      this.loading = false;
      
      console.log('Dimensiones cargadas:', this.dimensiones.length);
      
      return {
        success: true,
        data: this.dimensiones,
        message: 'Dimensiones cargadas exitosamente'
      };
    } catch (error) {
      console.error('Error al cargar dimensiones:', error);
      this.error = error.message;
      this.dimensiones = [];
      this.loading = false;
      throw error;
    }
  }

  async guardar(dimensionData) {
    try {
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const dataToSend = {
        ...dimensionData,
        EmpresaId: selectedEmpresa?.EmpresaId || dimensionData.EmpresaId
      };

      const response = await axios.post(getApiUrl('/api/CatDimension/guardar'), dataToSend, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      return {
        success: true,
        data: response.data,
        message: 'Dimensión guardada exitosamente'
      };
    } catch (error) {
      console.error('Error al guardar dimensión:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error al guardar dimensión'
      };
    }
  }

  async borrar(dimensionData) {
    try {
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const dataToSend = {
        ...dimensionData,
        EmpresaId: selectedEmpresa?.EmpresaId || dimensionData.EmpresaId
      };

      const response = await axios.post(getApiUrl('/api/CatDimension/borrar'), dataToSend, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      return {
        success: true,
        data: response.data,
        message: 'Dimensión eliminada exitosamente'
      };
    } catch (error) {
      console.error('Error al eliminar dimensión:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error al eliminar dimensión'
      };
    }
  }

  async lectura(clave) {
    try {
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const response = await axios.post(getApiUrl('/api/CatDimension/lectura'), {
        Clave: clave,
        EmpresaId: selectedEmpresa?.EmpresaId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error al leer dimensión:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error al leer dimensión'
      };
    }
  }

  async recargar() {
    await this.listar();
  }

  async downloadBulk() {
    try {
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const response = await axios.post(getApiUrl('/api/CatDimension/descarga-masiva'), {
        EmpresaId: selectedEmpresa?.EmpresaId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        responseType: 'blob'
      });

      // Crear enlace de descarga
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `dimensiones_${new Date().toISOString().split('T')[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return {
        success: true,
        message: 'Descarga iniciada correctamente'
      };
    } catch (error) {
      console.error('Error al descargar dimensiones:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error al descargar dimensiones'
      };
    }
  }
}

export default CatDimensionService;
